import React, { useEffect, useState } from "react";
import { Card } from 'primereact/card';
import LoginForm from "@/Components/Forms/LoginForm";
import FullscreenLayout from "@/Themes/Default/Layouts/FullscreenLayout";

/**
 * Site's login page
 */
const LoginPage = () => {
    useEffect(() => {
        document.title = 'Login' + ' · ' + document.title;
    }, []);

    return (
        <FullscreenLayout>
            <Card>
                <LoginForm />
            </Card>
            <div style={{ maxWidth: "275px", maxHeight: "163px", margin: "auto", paddingTop:"1rem" }}>
				<div style={{ position: "relative", paddingBottom: "59.1%", height: "auto", overflow: "hidden" }}>
					<iframe
						frameBorder="0"
						scrolling="no"
						src="https://cdn.yoshki.com/iframe/55849r.html"
						style={{
							border: "0px",
							margin: "auto",
							padding: "0px",
							backgroundColor: "transparent",
							top: "0px",
                            bottom:"0px",
							left: "0px",
                            right: "0px",
							width: "70%",
							height: "70%",
							position: "absolute"
						}}
					></iframe>
				</div>
			</div>
        </FullscreenLayout>
    );
};

export default LoginPage;